/**
 * Timestamp rendering shared by the Distribution screen's two tabs
 * (task 005-08). Admin-requirements §1.4 pins MM-DD-YYYY for list dates; an
 * ops log also needs the time of day, so the cell shows the date over the
 * local time and `fmtDateTime` (the full ISO stamp) rides the cell's tooltip.
 */

import { fmtDate, fmtDateTime } from '../../lib/format';

/** Local HH:mm:ss — the time half (fmtDate owns the date half). */
function localTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toTimeString().slice(0, 8);
}

/** `09-08-2026 14:10:08` — the visible reading of one timestamp. */
export function fmtWhen(iso: string): string {
  const date = fmtDate(iso);
  if (!date) return '';
  return `${date} ${localTime(iso)}`;
}

/** A table cell in the When / Last run column: date over local time. */
export function WhenCell({ iso }: { iso: string }) {
  return (
    <td
      className="whitespace-nowrap p-4 align-middle font-mono text-xs text-muted"
      title={fmtDateTime(iso)}
    >
      {fmtDate(iso)}
      <span className="block text-faint">{localTime(iso)}</span>
    </td>
  );
}
